import { PageType } from 'constants/pages';
import { RouteQueryParams } from 'providers/types';
import fetchDraft from 'services/CMSFetcher/fetchDraft';
import fetchWithFallback from 'services/CMSFetcher/fetchWithFallback';
import { StrapiResponseModel } from './types';

function buildApiPath({
  slug,
  queryParam,
  isDraft,
}: {
  slug: string;
  isDraft?: boolean;
  queryParam?: Record<string, string>;
  pageType?: PageType;
}) {
  const res: { path?: string; isDraft?: boolean } = { isDraft };

  const prefix = isDraft ? '' : 'landings';

  res.path = `${prefix}/${encodeURIComponent(slug)}`;

  if (queryParam) {
    const queryParams = Object.keys(queryParam)
      .map(item => `${item}=${queryParam[item]}`)
      .join('&');
    res.path += `?${queryParams}`;
  }

  return res;
}

export default async function getPageBySlug(args: {
  slug: string;
  isDraft?: boolean;
  queryParam?: RouteQueryParams;
  pageType: PageType;
}): Promise<StrapiResponseModel> {
  const { path, isDraft } = buildApiPath(args);

  return isDraft ? fetchDraft(path) : fetchWithFallback(path);
}
